export default {
  footerNewsletter: {
    title: 'Never miss a milestone',
    description: 'Get the latest quantum updates delivered to your inbox.',
    href: 'https://bit.ly/4u6rEfT',
    cta: 'Join the list',
  },
  footerAbout: {
    description:
      'PennyLane is an open-source quantum software platform for quantum computing, quantum machine learning, and quantum chemistry. Create meaningful quantum algorithms, from inspiration to implementation.',
    createdBy: 'Created with ❤️ by [Xanadu](https://xanadu.ai/).',
  },
  footerSocials: [
    {
      icon: 'bxl-linkedin',
      href: 'https://www.linkedin.com/company/pennylaneai/',
      ariaLabel: 'linkedin',
    },
    {
      icon: 'bxl-github',
      href: 'https://github.com/PennyLaneAI/pennylane',
      ariaLabel: 'github',
    },
    {
      icon: 'bxl-youtube',
      href: 'https://www.youtube.com/@pennylaneai/',
      ariaLabel: 'youtube',
    },
    {
      icon: 'bxl bx-twitter-x',
      href: 'https://twitter.com/PennyLaneAI',
      ariaLabel: 'twitter',
    },
    {
      icon: 'bxl-discord',
      href: 'https://discord.com/invite/gnySM3nrN3',
      ariaLabel: 'discord',
    },
    {
      icon: 'bxl-slack',
      href: 'https://join.slack.com/t/xanadu-quantum/shared_invite/zt-1i8v8v49d-S76QxXm3OKCm9g0bvWvDpg',
      ariaLabel: 'slack',
    },
    {
      icon: 'bxl-discourse',
      href: 'https://discuss.pennylane.ai',
      ariaLabel: 'discourse',
    },
  ],
  footerLinks: [
    {
      title: 'Research',
      links: [
        {
          name: 'Research',
          href: '/research',
        },
        {
          name: 'Performance',
          href: '/performance',
        },
        {
          name: 'Hardware and simulators',
          href: '/devices',
        },
        {
          name: 'Demos library',
          href: '/demonstrations',
        },
        {
          name: 'Compilation hub',
          href: '/compilation',
        },
        {
          name: 'Quantum datasets',
          href: '/datasets',
        },
      ],
    },
    {
      title: 'Education',
      links: [
        {
          name: 'Teach',
          href: '/education',
        },
        {
          name: 'Learn',
          href: '/learn',
        },
        {
          name: 'Codebook',
          href: '/codebook',
        },
        {
          name: 'Coding challenges',
          href: '/challenges',
        },
        {
          name: 'Videos',
          href: '/videos',
        },
        {
          name: 'Glossary',
          href: '/glossary',
        },
      ],
    },
    {
      title: 'Software',
      links: [
        {
          name: 'Install',
          href: '/install',
        },
        {
          name: 'Features',
          href: '/features',
        },
        {
          name: 'PennyLane documentation',
          href: 'https://docs.pennylane.ai',
        },
        {
          name: 'Catalyst documentation',
          href: 'https://docs.pennylane.ai/projects/catalyst/en/stable/',
        },
        {
          name: 'Development guide',
          href: 'https://docs.pennylane.ai/en/stable/development/guide.html',
        },
        {
          name: 'How-to guides',
          href: '/search?contentType=DEMO&categories=how-to&sort=publication_date',
        },
        {
          name: 'API',
          href: 'https://docs.pennylane.ai/en/stable/code/qp.html',
        },
        {
          name: 'GitHub',
          href: 'https://github.com/PennyLaneAI/pennylane',
        },
      ],
    },
  ],
  footerPolicies: [
    {
      text: 'Privacy policy',
      href: '/privacy',
    },
    {
      text: 'Terms of service',
      href: '/terms',
    },
    {
      text: 'Cookies policy',
      href: '/cookies',
    },
    {
      text: 'Code of conduct',
      href: '/conduct',
    },
  ],
}
